// frontend/src/pages/PayrollDone/usePaySchedule.ts
// React Query hook for a single pay schedule by id.

import { useQuery } from "@tanstack/react-query";
import { API_URL, authHeaders } from "./helpers";
import type { PaySchedule } from "./types";

/**
 * Fetches a single pay schedule by id.
 * Hook is disabled until a scheduleId is provided (the parent waits for the pay run data first).
 * Returns null on a non-OK response.
 */
export function usePaySchedule(scheduleId: string | undefined | null) {
  return useQuery<PaySchedule | null>({
    queryKey: ["pay-schedule", scheduleId],
    queryFn: async function () {
      const res = await fetch(
        API_URL + "/api/v1/payroll/schedules/" + scheduleId,
        { headers: authHeaders() }
      );
      if (!res.ok) return null;
      return await res.json();
    },
    enabled: !!scheduleId,
    refetchOnWindowFocus: false,
  });
}